import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function DynamicTitle() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    // Mapping of paths to titles
    const titles = {
      "/": "Home -  Lions Forge Contracting",
      "/about": "About Us -  Lions Forge Contracting",
      "/contact": "Contact Us -  Lions Forge Contracting",
      "/services/demolition": "Demolition Services -  Lions Forge Contracting",
      "/services/renovation": "Renovation Services -  Lions Forge Contracting",
      "/services/janitors": "Janitors Services -  Lions Forge Contracting",
      "/services/cleaning": "Post Cleaning -  Lions Forge Contracting",
      "/services/manpower": "Manpower -  Lions Forge Contracting",
      "/adminContact": "Admin Contacts -  Lions Forge Contracting"
    };

    document.title = titles[path] || " Lions Forge Contracting";
  }, [location]);

  return null; // This component doesn't render anything
}
